import React from 'react';
import { View, StyleSheet, ActivityIndicator } from 'react-native';
import FormField from 'ui/form/FormField';
import { Image } from '@rneui/themed';

import TableSelectArea from '../areas/TableSelectArea';
import { type TableMapType, type TableType } from 'types/Table';

const styles = StyleSheet.create({
  imageContent: {
    aspectRatio: 1,
    width: '50%',
    justifyContent: 'center',
  },
});

interface Props {
  value:
    | {
        image: string;
      }
    | undefined;
  setFieldValue: (date: TableType) => void;
  tableMapList: TableMapType[];
  tableList: TableType[];
  disabled: boolean;
}

const TableSelectForm: React.FC<Props> = ({
  value,
  setFieldValue,
  tableMapList,
  tableList,
  disabled,
}) => {
  return (
    <>
      {value !== null ? (
        <View>
          <Image
            source={{ uri: value?.image }}
            containerStyle={styles.imageContent}
            PlaceholderContent={<ActivityIndicator />}
          />
        </View>
      ) : (
        <></>
      )}
      <TableSelectArea
        tableMapList={tableMapList}
        tableList={tableList}
        setFieldValue={setFieldValue}
        disabled={disabled}
      />
    </>
  );
};

TableSelectForm.defaultProps = {
  value: undefined,
};

export default FormField(TableSelectForm);
